import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'shortcutHelpModal.title',
		defaultMessage: 'Keyboard shortcuts',
		description: 'Title of the modal that lists the media player keyboard shortcuts',
	},
	playPause: {
		id: 'shortcutHelpModal.action.playPause',
		defaultMessage: 'Play or pause',
		description: 'Shortcut action that toggles playback',
	},
	skipBack: {
		id: 'shortcutHelpModal.action.skipBack',
		defaultMessage: 'Back 15 seconds',
		description: 'Shortcut action that rewinds the media by 15 seconds',
	},
	skipForward: {
		id: 'shortcutHelpModal.action.skipForward',
		defaultMessage: 'Forward 15 seconds',
		description: 'Shortcut action that fast-forwards the media by 15 seconds',
	},
	restart: {
		id: 'shortcutHelpModal.action.restart',
		defaultMessage: 'Restart',
		description: 'Shortcut action that seeks back to the start of the media',
	},
	jump: {
		id: 'shortcutHelpModal.action.jump',
		defaultMessage: 'Jump to 10% to 90%',
		description: 'Shortcut action where number keys 1 to 9 jump to that tenth of the media',
	},
	mute: {
		id: 'shortcutHelpModal.action.mute',
		defaultMessage: 'Mute or unmute',
		description: 'Shortcut action that toggles mute',
	},
	fullscreen: {
		id: 'shortcutHelpModal.action.fullscreen',
		defaultMessage: 'Fullscreen (video only)',
		description: 'Shortcut action that toggles fullscreen, available for video content only',
	},
	close: {
		id: 'shortcutHelpModal.action.close',
		defaultMessage: 'Close the player',
		description: 'Shortcut action that stops playback and closes the player',
	},
	help: {
		id: 'shortcutHelpModal.action.help',
		defaultMessage: 'Show keyboard shortcuts',
		description: 'Shortcut action that opens this list of shortcuts',
	},
	keySpace: {
		id: 'shortcutHelpModal.key.space',
		defaultMessage: 'Space',
		description: 'Name of the space bar key',
	},
	keyLeft: {
		id: 'shortcutHelpModal.key.left',
		defaultMessage: 'Left arrow',
		description: 'Name of the left arrow key',
	},
	keyRight: {
		id: 'shortcutHelpModal.key.right',
		defaultMessage: 'Right arrow',
		description: 'Name of the right arrow key',
	},
	keyHome: {
		id: 'shortcutHelpModal.key.home',
		defaultMessage: 'Home',
		description: 'Name of the Home key',
	},
	keyEscape: {
		id: 'shortcutHelpModal.key.escape',
		defaultMessage: 'Esc',
		description: 'Name of the Escape key',
	},
	keyDigits: {
		id: 'shortcutHelpModal.key.digits',
		defaultMessage: '1 to 9',
		description: 'The number keys 1 through 9',
	},
});
